module.exports = __webpack_public_path__ + "media/interested_companies/images/star02-d8242fef8505073264be21a3a80b48f4.svg";